export default __webpack_public_path__ + "static/media/main-logo.1e11e8ce.svg";